"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeColor = void 0;
const HslColor_1 = require("./HslColor");
const DEFAULT_BG = HslColor_1.HslColor.from('#fff');
const clamp = (value, min, max) => {
    return Math.min(Math.max(value, min), max);
};
class ThemeColor {
    constructor(fg, bg = DEFAULT_BG) {
        this.fg = fg;
        this.bg = bg;
    }
    isDarkTheme() {
        return this.bg.l < 0.5;
    }
    /**
     * @param contrast Contrast with background: 1 - highest, 0 - lowest.
     * @param alpha The alpha channel level.
     */
    g(contrast = 1, alpha = this.fg.a) {
        return this.col(contrast, alpha).toString();
    }
    col(contrast = 0, alpha = this.fg.a) {
        const isDark = this.isDarkTheme();
        const bgL = this.bg.l;
        const fgS = this.fg.s;
        const lightness = isDark ? bgL + (1 - bgL) * contrast : bgL - bgL * contrast;
        const saturation = clamp(fgS + (isDark ? 1 : -1) * contrast * 0.5, 0, 1);
        // const saturation = fgS;
        const newHsl = new HslColor_1.HslColor(this.fg.h, saturation, lightness, alpha);
        return new ThemeColor(newHsl, this.bg);
    }
    toDarkTheme(bgDark) {
        const dContrast = this.bg.l - this.fg.l;
        const newL = clamp(bgDark.l + dContrast, 0, 1);
        const newS = this.fg.s > 0.6 ? this.fg.s * 0.9 : this.fg.s;
        const newH = this.fg.h;
        return new ThemeColor(new HslColor_1.HslColor(newH, newS, newL, this.fg.a), bgDark);
    }
    lerp(other, t) {
        return new ThemeColor(this.fg.mix(other.fg, t), this.bg.mix(other.bg, t));
    }
    toString() {
        return this.fg.toString();
    }
}
exports.ThemeColor = ThemeColor;
